import { supabase } from './supabase';

const FUNCTION_NAME = 'profilo-price-import';

export async function profiloPreviewImport(file: File, priceType: string = 'normal') {
  const base64 = await fileToBase64(file);
  const { data: sessionData } = await supabase.auth.getSession();
  const userId = sessionData?.session?.user?.id;

  if (!userId) return { error: 'Oturum bulunamadı' };

  const { data: bizData } = await supabase
    .from('business_members')
    .select('business_id')
    .eq('user_id', userId)
    .eq('status', 'Aktif')
    .maybeSingle();

  const businessId = bizData?.business_id;
  if (!businessId) return { error: 'İşletme bilgisi bulunamadı' };

  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, {
    body: {
      action: 'preview',
      fileBase64: base64,
      fileName: file.name,
      businessId,
      userId,
      priceType,
    },
  });

  if (error) {
    console.error('profiloPreviewImport error:', error);
    return { error: error.message || 'Önizleme oluşturulamadı' };
  }

  return data || {};
}

export async function profiloCommitImport(
  previewItems: any[],
  fileName: string,
  period: any,
  priceType: string = 'normal'
) {
  const { data: sessionData } = await supabase.auth.getSession();
  const userId = sessionData?.session?.user?.id;

  if (!userId) return { error: 'Oturum bulunamadı' };

  const { data: bizData } = await supabase
    .from('business_members')
    .select('business_id')
    .eq('user_id', userId)
    .eq('status', 'Aktif')
    .maybeSingle();

  const businessId = bizData?.business_id;
  if (!businessId) return { error: 'İşletme bilgisi bulunamadı' };

  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, {
    body: {
      action: 'commit',
      previewItems,
      fileName,
      period,
      businessId,
      userId,
      priceType,
    },
  });

  if (error) {
    console.error('profiloCommitImport error:', error);
    return { error: error.message || 'İçe aktarma başarısız' };
  }

  return data || {};
}

export async function profiloListImportBatches() {
  const { data: sessionData } = await supabase.auth.getSession();
  const userId = sessionData?.session?.user?.id;

  if (!userId) return { error: 'Oturum bulunamadı', batches: [] };

  const { data: bizData } = await supabase
    .from('business_members')
    .select('business_id')
    .eq('user_id', userId)
    .eq('status', 'Aktif')
    .maybeSingle();

  const businessId = bizData?.business_id;
  if (!businessId) return { error: 'İşletme bilgisi bulunamadı', batches: [] };

  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, {
    body: {
      action: 'list_batches',
      businessId,
      userId,
    },
  });

  if (error) {
    console.error('profiloListImportBatches error:', error);
    return { error: error.message || 'Geçmiş yüklenemedi', batches: [] };
  }

  return data || { batches: [] };
}

export async function profiloGetBatchItems(batchId: string) {
  const { data: sessionData } = await supabase.auth.getSession();
  const userId = sessionData?.session?.user?.id;

  if (!userId) return { error: 'Oturum bulunamadı', items: [] };

  const { data: bizData } = await supabase
    .from('business_members')
    .select('business_id')
    .eq('user_id', userId)
    .eq('status', 'Aktif')
    .maybeSingle();

  const businessId = bizData?.business_id;
  if (!businessId) return { error: 'İşletme bilgisi bulunamadı', items: [] };

  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, {
    body: {
      action: 'get_batch_items',
      batchId,
      businessId,
      userId,
    },
  });

  if (error) {
    console.error('profiloGetBatchItems error:', error);
    return { error: error.message || 'Detay yüklenemedi', items: [] };
  }

  return data || { items: [] };
}

export async function profiloGetCostHistory(productId: string) {
  const { data: sessionData } = await supabase.auth.getSession();
  const userId = sessionData?.session?.user?.id;

  if (!userId) return { error: 'Oturum bulunamadı', history: [] };

  const { data: bizData } = await supabase
    .from('business_members')
    .select('business_id')
    .eq('user_id', userId)
    .eq('status', 'Aktif')
    .maybeSingle();

  const businessId = bizData?.business_id;
  if (!businessId) return { error: 'İşletme bilgisi bulunamadı', history: [] };

  const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, {
    body: {
      action: 'get_cost_history',
      productId,
      businessId,
      userId,
    },
  });

  if (error) {
    console.error('profiloGetCostHistory error:', error);
    return { error: error.message || 'Geçmiş yüklenemedi', history: [] };
  }

  return data || { history: [] };
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const statusLabels: Record<string, string> = {
  new: 'Yeni Ürün',
  update: 'Güncellenecek',
  unchanged: 'Değişmedi',
  error: 'Hata',
  skipped: 'Atlandı',
};

export const statusColors: Record<string, string> = {
  new: 'bg-emerald-100 text-emerald-700',
  update: 'bg-amber-100 text-amber-700',
  unchanged: 'bg-background-100 text-foreground-500',
  error: 'bg-red-100 text-red-700',
  skipped: 'bg-foreground-100 text-foreground-400',
};